import React, { useState } from 'react';
import SignIn from 'Pages/UserAuth/SignIn';
import SignUp from 'Pages/UserAuth/SignUp';
import OAuthMoreDetails from 'Pages/UserAuth/OAuthMoreDetails';

function UserAuthentication() {
  const [authInterface, setAuthInterface] = useState(1);

  const [userImage, setUserImage] = useState('');

  const [userEmail, setUserEmail] = useState('');

  const renderAuthComponent = () => {
    switch (authInterface) {
      case 1:
        return (
          <SignIn
            isModal
            setUserEmail={setUserEmail}
            setUserImage={setUserImage}
            setAuthInterface={setAuthInterface}
          />
        );
      case 2:
        return (
          <SignUp
            isModal
            setUserEmail={setUserEmail}
            setUserImage={setUserImage}
            setAuthInterface={setAuthInterface}
          />
        );
      case 3:
        return (
          <OAuthMoreDetails
            isModal
            userEmail={userEmail}
            userImage={userImage}
          />
        );
      default:
        return (
          <SignIn
            isModal
            setUserEmail={setUserEmail}
            setUserImage={setUserImage}
            setAuthInterface={setAuthInterface}
          />
        );
    }
  };

  return <>{renderAuthComponent()}</>;
}

export default UserAuthentication;
